/**
 * Dev-only logger utility.
 * Calls are no-ops in production builds (when NODE_ENV === 'production').
 *
 * Usage:
 *   import { devLog, devWarn, devError } from '@/lib/logger';
 *   devLog('[Auth] Session loaded', session);
 *   devWarn('[Payment] Retry needed');
 */

const isDev = import.meta.env.DEV;

export function devLog(...args: unknown[]): void {
  if (isDev) console.log(...args);
}

export function devWarn(...args: unknown[]): void {
  if (isDev) console.warn(...args);
}

export function devError(...args: unknown[]): void {
  // Errors are always logged (useful for Sentry / monitoring in prod too)
  console.error(...args);
}
